import React, { useState, useCallback, useEffect } from 'react';

const OccupationSearch = ({
    currentQuestion,
    storeAnswers,
    removeAnswer,
    parentAnswerKey,
    selectedAnswer,
    subQuestion,
}) => {
    const [searchText, setSearchText] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    // Hard coded this as for some reason it's not getting passed through in the props.
    parentAnswerKey = 2;

    if (searchText.length === 0 && searchResults.length === 0) {
        if (subQuestion && selectedAnswer.hasOwnProperty(parentAnswerKey)) {
            //setSearchText(selectedAnswer[parentAnswerKey].text);
        }
    }

    const fetchOccupationData = useCallback(() => {
        fetch(`https://nu-partners-api.herokuapp.com/api/v1/occupation/searchRecord/${searchText}`)
            .then((response) => {
                if (response.status !== 200) {
                    console.error(`Looks like there was a problem. Status Code: ${response.status}`);

                    return;
                }

                response.json().then((data) => {
                    if (data.length > 0) {
                        const occupationData = data;

                        if (occupationData.length > 0) {
                            let occupationList = occupationData;

                            if (occupationData.length === 1 && occupationData[0].name === searchText) {
                                return;
                            }

                            if (searchText.length > 0) {
                                occupationList = occupationList.filter((occupation) =>
                                    occupation.name.toLowerCase().includes(searchText.toLowerCase())
                                );
                            }

                            if (occupationList.length === 0) {
                                setErrorMessage(
                                    'Sorry no matches for that occupation. Try skipping to the next question.'
                                );
                                setSearchResults([]);

                                return;
                            }

                            setSearchResults(occupationList);
                            setErrorMessage('');
                        } else {
                            setSearchResults([]);
                            setErrorMessage('Sorry no matches for that occupation. Try skipping to the next question.');
                        }
                    }
                });
            })
            .catch((error) => {
                console.error(error);
            });
    }, [searchText]);

    useEffect(() => {
        if (searchText.length < 3) {
            return;
        }

        fetchOccupationData();
    }, [searchText, fetchOccupationData]);

    const handleResultClick = (event) => {
        const eligible = event.target.getAttribute('data-eligible') === 'true' ? true : false;

        setSearchText(event.target.innerHTML);
        setSearchResults([]);
        setErrorMessage('');

        storeAnswers(
            0,
            {
                text: event.target.innerHTML,
                eligible: eligible,
                nextQuestion: eligible ? null : 13,
            },
            currentQuestion,
            parentAnswerKey
        );
    };

    const handleSearchClick = (event) => {
        fetchOccupationData();
    };

    const handleSearchTextChange = (event) => {
        setSearchText(event.target.value);
    };

    const handleOnKeyPressed = (e) => {
        const code = e.keyCode || e.which;
        if (code === 13) {
            //13 is the enter keycode
            fetchOccupationData();
        }
    };

    return (
        <>
            <div className='searchWrapper long'>
                <input
                    className='searchText'
                    type='text'
                    onChange={handleSearchTextChange}
                    onKeyUp={handleOnKeyPressed}
                    value={searchText}
                />
                <button className='searchTextIcon' onClick={handleSearchClick} />
                {searchResults && (
                    <div className='searchResults'>
                        {searchResults.map((searchResult) => {
                            return (
                                <span
                                    onClick={handleResultClick}
                                    data-eligible={searchResult.eligible === 1 ? true : false}
                                    data-default={false}
                                >
                                    {searchResult.name}
                                </span>
                            );
                        })}
                        {searchResults.length > 9 && <span className='moreText'>Scroll for more</span>}
                    </div>
                )}
                {errorMessage && <p className='searchMessage error'>{errorMessage}</p>}
            </div>
        </>
    );
};

export default OccupationSearch;
